import { Empty } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useCreateEvent } from "../../../shared/events/save/CreateEventProvider";
import { SaveEvent } from "../../../shared/events/save/SaveEvent";
import { useEventSave } from "./useEventSave";

export const CreateEventPage: FC = () => {
	const { t } = useTranslation();
	const { viewType = "" } = useParams<{ viewType: string }>();
	const handleSave = useEventSave(viewType);
	const { initialValues } = useCreateEvent();

	if (initialValues === null) {
		return <Empty>{t("To create an event use the add-Button on the overview.")}</Empty>;
	}

	return <SaveEvent variant="outlined" initialValues={initialValues} onSubmit={handleSave} />;
};
